import type { HeroBannerProps } from '@/components/HeroBanner/HeroBanner.types'
import { actionIconsDefaultProps as actionIcons } from '@/components/Markets/ActionIcons/ActionIcons.constants'
import { defaultActiveButtonsProps as activeButtons } from '@/components/ActiveButtons/ActiveButtons.constants'

export const heroBannerDefaultProps: Partial<HeroBannerProps> = {
  title: '',
  subTitle: '',
  withBreadcrumbs: false,
  withActionIcons: false,
  withActiveButtons: false,
  actionIcons,
  activeButtons
}
